var pattern = /^[\uD83C-\uDBFF\uDC00-\uDFFF]+$/;
/**
 * Определяет является ли текст emoji
 * @param {string} text
 * @return {boolean}
 */

function isEmoji(text) {
  return pattern.test(text);
}

export { isEmoji };